import axios from "axios";
import { removeToken } from "./auth";
import { API_BASE_URL } from "./api";

axios.defaults.baseURL = API_BASE_URL;

const redirectToSignIn = () => {
  if (typeof window === "undefined") return;

  const pathname = window.location.pathname;
  const skipRedirect = [
    "/auth/sign-in",
    "/auth/forgot-password",
    "/auth/reset-password",
    "/reset-password",
  ].some((route) => pathname.startsWith(route));
  if (skipRedirect) return;

  try {
    removeToken();
  } catch (e) {
    // ignore
  }

  window.location.href = "/auth/sign-in";
};

const isUnauthorizedResponse = (response) => {
  if (!response || typeof response !== "object") return false;
  if (response.status === 401) return true;
  const body = response.data;
  return body && body.statusCode === 401;
};

const isForbiddenPermissionResponse = (response) => {
  if (!response || typeof response !== "object") return false;
  return (
    response.status === 403 &&
    response.data?.message === "Forbidden. You do not have permission."
  );
};

const showPermissionAlert = (response) => {
  const message = response.data?.message || "Forbidden. You do not have permission.";

  if (typeof window !== "undefined" && typeof window.__showPermissionModal === "function") {
    window.__showPermissionModal("Permission denied", message);
    return;
  }

  if (typeof window !== "undefined" && typeof window.__showToast === "function") {
    window.__showToast(message, "error");
  }
};

axios.interceptors.response.use(
  (response) => {
    if (isUnauthorizedResponse(response)) {
      redirectToSignIn();
      return Promise.reject(new Error("Unauthorized"));
    }

    if (isForbiddenPermissionResponse(response)) {
      showPermissionAlert(response);
      return Promise.reject(new Error(response.data?.message || "Forbidden"));
    }

    return response;
  },
  (error) => {
    if (isUnauthorizedResponse(error.response)) {
      redirectToSignIn();
      return Promise.reject(error);
    }

    if (isForbiddenPermissionResponse(error.response)) {
      showPermissionAlert(error.response);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axios;
